export const ROLES = [
  ["super_admin", "Super Admin", "Full access to everything, including the Team."],
  ["editor", "Editor", "Can view and edit only the areas you tick below."],
  ["viewer", "Viewer", "Can only look at the areas you tick below. No changes."],
];
export const ROLE_LABEL = Object.fromEntries(ROLES.map(([k, l]) => [k, l]));

export const AREAS = [
  ["sermons", "Messages"],
  ["announcements", "Announcements"],
  ["text", "Website Text"],
  ["schedule", "Schedule"],
  ["settings", "Settings"],
  ["gifts", "Gifts"],
  ["pages", "Pages"],
  ["gallery", "Events/Programs"],
  ["design", "Visual Editor"],
];

export const canRead = (u, area) => u?.role === "super_admin" || (u?.areas || []).includes(area);
export const canWrite = (u, area) => u?.role === "super_admin" || (u?.role === "editor" && (u?.areas || []).includes(area));
export const isSuper = (u) => u?.role === "super_admin";
